/* Compact header search with predictive results (Shopify /search/suggest.json). */
if (!customElements.get('smart-search')) {
  customElements.define('smart-search', class SmartSearch extends HTMLElement {
    connectedCallback() {
      this.mtrigger = this.querySelector('.ss__mtrigger');
      this.panel = this.querySelector('.ss__panel');
      this.scrim = this.querySelector('.ss__scrim');
      this.input = this.querySelector('.ss__input');
      this.clearBtn = this.querySelector('.ss__clear');
      this.title = this.querySelector('.ss__title');
      this.count = this.querySelector('.ss__count');
      this.plabel = this.querySelector('.ss__plabel');
      this.sugs = this.querySelector('.ss__sugs');
      this.products = this.querySelector('.ss__products');
      this.all = this.querySelector('.ss__all');
      this.strings = this.querySelector('.ss__strings').dataset;
      this.idleSugs = this.sugs.innerHTML;
      this.idleProducts = this.products.innerHTML;
      this.limit = parseInt(this.dataset.limit, 10) || 5;
      try {
        this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, maximumFractionDigits: 2 });
      } catch (e) {
        this.money = new Intl.NumberFormat(undefined, { style: 'currency', currency: this.dataset.currency });
      }
      this.cache = new Map();
      this.active = -1;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      this.mtrigger.addEventListener('click', () => this.open());
      this.input.addEventListener('focus', () => this.open());
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.clearBtn.addEventListener('click', () => { this.input.value = ''; this.onInput(); this.input.focus(); });
      this.querySelector('.ss__cancel').addEventListener('click', () => this.close());
      this.scrim.addEventListener('click', () => this.close());
      this.panel.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
      document.addEventListener('keydown', (e) => {
        const tag = (e.target.tagName || '').toLowerCase();
        if (e.key === '/' && !this.isOpen && this.offsetParent !== null && tag !== 'input' && tag !== 'textarea' && !e.target.isContentEditable) {
          e.preventDefault();
          this.input.focus();
        }
      });
      document.addEventListener('click', (e) => { if (this.isOpen && !this.contains(e.target)) this.close(); });
    }

    get isOpen() { return !this.panel.hidden; }

    open() {
      if (this.isOpen) return;
      this.panel.hidden = false;
      this.scrim.hidden = false;
      this.classList.add('is-open');
      if (window.matchMedia('(max-width: 991px)').matches) document.documentElement.classList.add('ss-lock');
      this.input.setAttribute('aria-expanded', 'true');
      if (document.activeElement !== this.input) requestAnimationFrame(() => this.input.focus());
    }

    close() {
      if (!this.isOpen) return;
      this.panel.hidden = true;
      this.scrim.hidden = true;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('ss-lock');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.blur();
    }

    onInput() {
      const q = this.input.value.trim();
      this.clearBtn.hidden = !this.input.value;
      clearTimeout(this.timer);
      if (!q) { this.render(null); return; }
      this.timer = setTimeout(() => this.search(q), 180);
    }

    async search(q) {
      if (this.cache.has(q)) { this.render(this.cache.get(q), q); return; }
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product,query',
        'resources[limit]': this.limit,
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,product_type,variants.title,vendor,tag'
      });
      try {
        const res = await fetch(`${this.root}search/suggest.json?${params}`, { signal: this.controller.signal });
        const data = (await res.json()).resources.results;
        this.cache.set(q, data);
        if (this.input.value.trim() === q) this.render(data, q);
      } catch (e) {
        if (e.name !== 'AbortError') this.render({ products: [], queries: [] }, q);
      }
    }

    esc(s) { const d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

    img(url, w) {
      if (!url) return '';
      try { const u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
    }

    searchUrl(q) { return `${this.root}search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`; }

    render(data, q) {
      this.active = -1;
      const s = this.strings;
      if (!data) {
        this.title.textContent = this.title.dataset.idle;
        this.plabel.textContent = this.plabel.dataset.idle;
        this.count.textContent = '';
        this.sugs.innerHTML = this.idleSugs;
        this.products.innerHTML = this.idleProducts;
        this.all.hidden = true;
        this.classList.remove('is-live');
        return;
      }
      this.classList.add('is-live');
      this.title.textContent = `${this.title.dataset.live} “${q}”`;
      this.plabel.textContent = this.plabel.dataset.live;
      const products = data.products || [];
      const icon = this.sugs.querySelector('svg');
      const iconHtml = icon ? icon.outerHTML : '';
      const queries = (data.queries || []).slice(0, 4);
      this.sugs.innerHTML = queries.length
        ? queries.map((x) => `<li><a class="ss__sug ss__opt" role="option" href="${this.esc(x.url)}">${iconHtml}<span>${x.styled_text || this.esc(x.text)}</span></a></li>`).join('')
        : `<li><a class="ss__sug ss__opt" role="option" href="${this.searchUrl(q)}">${iconHtml}<span>${this.esc(q)}</span></a></li>`;
      this.count.textContent = products.length ? `${products.length} ${s.count}` : '';
      this.products.innerHTML = products.length
        ? products.map((p) => {
          const price = parseFloat(p.price);
          const compare = parseFloat(p.compare_at_price_max);
          const imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          return `<a class="ss__product ss__opt" role="option" href="${this.esc(p.url)}">
            <span class="ss__thumb">${imgUrl ? `<img src="${this.esc(this.img(imgUrl, 120))}" alt="" width="52" height="52" loading="lazy">` : ''}</span>
            <span class="ss__pinfo"><span class="ss__ptitle">${this.esc(p.title)}</span>${p.type ? `<span class="ss__psub">${this.esc(p.type)}</span>` : ''}</span>
            <span class="ss__pright"><span class="ss__price">${p.available ? '' : `<em>${this.esc(s.soldout)}</em> `}${isNaN(price) ? '' : this.money.format(price)}${compare > price ? ` <s>${this.money.format(compare)}</s>` : ''}</span><span class="ss__view">${this.esc(s.viewproduct)} &rarr;</span></span>
          </a>`;
        }).join('')
        : `<p class="ss__empty">${this.esc(s.empty)} “${this.esc(q)}”</p>`;
      this.all.href = this.searchUrl(q);
      this.all.innerHTML = `${this.esc(s.viewall)} “${this.esc(q)}” &rarr;`;
      this.all.hidden = false;
    }

    onKey(e) {
      const opts = [...this.panel.querySelectorAll('.ss__opt')].filter((el) => !el.hidden && el.offsetParent !== null);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!opts.length) return;
        this.active = e.key === 'ArrowDown' ? (this.active + 1) % opts.length : (this.active - 1 + opts.length) % opts.length;
        opts.forEach((el, i) => el.classList.toggle('is-active', i === this.active));
        opts[this.active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.active > -1 && opts[this.active]) {
        e.preventDefault();
        window.location.href = opts[this.active].href;
      } else if (e.key === 'Escape') {
        this.close();
      }
    }
  });
}
